// src/pages/Accounting/Receipts/constants.ts

import type { ReceiptSource, ReceiptMatchStatus, FilterKey } from "./types";

export const PALETTE = {
  ink: "#0E1A1A",
  ink2: "#263238",
  ink3: "#3A4A52",
  ink4: "#6B7684",
  line: "#D8DEE6",
  lineSoft: "#E7EAF0",
  panel: "#F7F8FA",
  tealDark: "#0F6E56",
  amber: "#F59E0B",
  amberInk: "#92400E",
  red: "#DC2626",
  velaDeep: "#4C1D95",
  vela: "#6B46C1",
  velaLight: "#8B5CF6",
  velaWash: "#EDE9FE",
  velaFade: "#F5F3FF",
} as const;

// File constraints
export const SUPPORTED_FORMATS = ["pdf", "png", "jpg", "jpeg", "heic"] as const;
export const SUPPORTED_FORMATS_LABEL = "PDF, PNG, JPG, HEIC";
export const MAX_FILE_SIZE_MB = 25;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

// Branded forward email domain
export const RECEIPT_EMAIL_DOMAIN = "novala.app";

// Human-readable labels
export const SOURCE_LABELS: Record<ReceiptSource, string> = {
  mobile: "from mobile",
  email: "from email",
  upload: "from upload",
  manual: "entered manually",
};

export const MATCH_STATUS_LABELS: Record<ReceiptMatchStatus, string> = {
  matched: "Auto",
  "needs-review": "Review",
  unmatched: "Unmatched",
  processing: "Processing",
};

export const FILTER_LABELS: Record<FilterKey, string> = {
  all: "All",
  matched: "Matched",
  "needs-review": "Needs review",
  unmatched: "Unmatched",
  processing: "Processing",
};

// Common expense categories (user can customize later)
export const DEFAULT_CATEGORIES = [
  "Vehicle expenses",
  "Office supplies",
  "Meals & entertainment",
  "Travel",
  "Professional services",
  "Software & subscriptions",
  "Utilities",
  "Rent",
  "Insurance",
  "Marketing & advertising",
  "Shipping & postage",
  "Training & education",
  "Other",
] as const;